$.fn.dataTableExt.oApi.fnDisplayUpdatedData = function ( oSettings, aData ) {
	var displayPos = -1, dataPos = -1;
	for(let i = 0, iLen = oSettings.aiDisplay.length ; i < iLen ; i++ ) {
		if( oSettings.aoData[ oSettings.aiDisplay[i] ]._aData == aData ) {
			displayPos = i;
			dataPos = oSettings.aiDisplay[i];
			break;
		}
	}

	if(displayPos >= 0) {
		var row = this.api().row(dataPos);
		row.invalidate().draw();
		var rowNode = row.node();
		if(!rowNode) {
			return;
		}

		for(let i = 0; i < oSettings.aoColumns.length; i++) {
			var aoCol = oSettings.aoColumns[i];

			var col = rowNode.childNodes[i];
			if(aoCol.createdCell) {
				var value;
				if(typeof aoCol.data === 'function') {
					value = aoCol.data(aData);
				} else {
					value = aData[aoCol.data];
				}
				aoCol.createdCell(col, value, aData);
			}
		}

		oSettings._iDisplayStart = ( Math.floor(displayPos / oSettings._iDisplayLength) ) * oSettings._iDisplayLength;
		if ( this.oApi._fnCalculateEnd ) {
			this.oApi._fnCalculateEnd( oSettings );
		}
		this.oApi._fnDraw( oSettings );
	}
};

// http://datatables.net/plug-ins/api/fnAddDataAndDisplay
$.fn.dataTableExt.oApi.fnAddDataAndDisplay = function ( oSettings, aData ) {
	/* Add the data */
	var iAdded = this.oApi._fnAddData( oSettings, aData );
	var nAdded = oSettings.aoData[ iAdded ].nTr;

	/* Need to re-filter and re-sort the table to get positioning correct, not perfect
	 * as this will actually redraw the table on screen, but the update should be so fast (and
	 * possibly not alter what is already on display) that the user will not notice
	 */
	this.oApi._fnReDraw( oSettings );

	var me = this;
	window.setTimeout(function() {
		me.oApi.fnHighlightRow.call(me, oSettings, aData);
	}, 1);

	return {
		"nTr": nAdded,
		"iPos": iAdded
	};
};

$.fn.dataTableExt.oApi.fnHighlightRow = function(oSettings, aData) {
	var displayPos = -1, dataPos = -1;
	for(var i=0, iLen = oSettings.aiDisplay.length ; i < iLen ; i++ ) {
		if( oSettings.aoData[ oSettings.aiDisplay[i] ]._aData == aData ) {
			displayPos = i;
			dataPos = oSettings.aiDisplay[i];
			break;
		}
	}

	if(displayPos >= 0) {
		oSettings._iDisplayStart = (Math.floor(i / oSettings._iDisplayLength)) * oSettings._iDisplayLength;
		if (this.oApi._fnCalculateEnd) {
			this.oApi._fnCalculateEnd(oSettings);
		}
		this.oApi._fnDraw(oSettings);

		var row = this.api().row(dataPos);
		var rowNode = row.node();
		if(!rowNode) {
			return;
		}

		$(rowNode).flashRed();
	}
};

$.fn.dataTableExt.oApi.fnRemoveData = function ( oSettings, aData ) {
	var displayPos = -1, dataPos = -1;
	for(var i=0, iLen = oSettings.aiDisplay.length ; i < iLen ; i++ ) {
		if( oSettings.aoData[ oSettings.aiDisplay[i] ]._aData == aData ) {
			displayPos = i;
			dataPos = oSettings.aiDisplay[i];
			break;
		}
	}

	if(displayPos >= 0) {
		var row = this.api().row(dataPos);
		row.remove().draw();
	}
};

$.fn.dataTableExt.oApi.fnReloadNewAjax = function(oSettings, data) {
	$(this).dataTable().fnClearTable();
	$(this).DataTable().ajax.url(data).load();
	$(this).find('.dataTables_empty').text('Loading');
};